import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  useTheme,
} from '@mui/material';

/** small Chip + flex gap(0.5) 기준 한 줄 높이(px) */
const CHIP_LINE_HEIGHT_PX = 28;

const MultiChipSelect = ({
  items = [],
  value = [],
  onChange,
  onClose,
  label = '선택',
  onClick,
  onFocus,
  disabled = false,
  labelYn = true,
  MenuProps,
  sx = {},
  labelSx = {},
  /** 최대 chip 줄 수(초과 시 말줄임 chip 표시) */
  maxChipLines,
  /** 한 줄에 들어갈 chip 개수 추정(말줄임·maxHeight 계산용) */
  estimatedChipsPerRow = 3,
  overflowChipLabel = '...',
}) => {
  const theme = useTheme();

  const getStyles = (name, selected, theme) => ({
    fontWeight:
      selected.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  });

  return (
    <FormControl fullWidth>
      {labelYn && <InputLabel id="multi-chip-label">{label}</InputLabel>}
      <Select
        labelId="multi-chip-label"
        multiple
        value={value}
        onChange={onChange}
        onClose={onClose}
        onClick={onClick}
        onFocus={onFocus}
        disabled={disabled}
        displayEmpty
        MenuProps={MenuProps}
        input={
          <OutlinedInput label="" notched={false} sx={{ pt: 1.0, pb: 1.0 }} />
        }
        sx={sx}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) return null;

          const maxVisible =
            maxChipLines != null
              ? maxChipLines * estimatedChipsPerRow
              : selected.length;
          const hasOverflow =
            maxChipLines != null && selected.length > maxVisible;
          const displayValues = hasOverflow
            ? selected.slice(0, Math.max(0, maxVisible - 1))
            : selected;

          return (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5,
                alignItems: 'flex-start',
                width: '100%',
                ...(maxChipLines != null && {
                  maxHeight: maxChipLines * CHIP_LINE_HEIGHT_PX,
                  overflow: 'hidden',
                }),
              }}
            >
              {displayValues.map((val) => {
                const item = items.find(
                  (i) => i.value === val || i.label === val
                );
                return (
                  <Chip key={val} size="small" label={item?.label ?? val} />
                );
              })}
              {hasOverflow ? (
                <Chip
                  key="__chip_overflow__"
                  size="small"
                  label={overflowChipLabel}
                  sx={{ flexShrink: 0 }}
                />
              ) : null}
            </Box>
          );
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            style={getStyles(item.value, value, theme)}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiChipSelect;
